import React, { Component } from "react";
import NavBar from "./components/navBar";
import { Router, Route, Switch } from "react-router-dom";
import UsersImage from "./Images/signIn/user.png";
import PwImage from "./Images/signIn/pw.png";
import Logo from "./Images/logo.png";
import {
  Home,
  Trainer,
  Mission,
  Courses,
  Admin,
  MyLearning,
  Gallery,
  Login,
  Faqs,
  CoursesPage,
} from "./pages";
import { createBrowserHistory } from "history";
import Particles from "react-particles-js";
import { Drawer, Button, message, notification } from "antd";
import { WarningTwoTone } from "@ant-design/icons";
import "./index.css";
import { Label } from "reactstrap";
import Footer from "./components/footer";

const particlesOptions = {
  particles: {
    number: {
      value: 20,
      density: {
        enable: true,
        value_area: 1000,
      },
    },
    line_linked: {
      enable: false,
    },
    move: {
      speed: 1,
      out_mode: "out",
    },
    shape: {
      type: ["image", "image", "image"],
      image: [
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
      ],
    },
    color: {
      value: "#CCC",
    },
    size: {
      value: 100,
      random: true,
      anim: {
        enable: true,
        speed: 4,
        size_min: 10,
        sync: false,
      },
    },
  },
  retina_detect: true,
};

const key = "updatable";

let hist = createBrowserHistory();
export default class APP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blurChecker: false,
      visible: true,
      childrenDrawer: false,
      signInEmail: "",
      signInPassword: "",
      user: [],
      errors: {},
      loadings: [],
      isSignedIn: false,
      //CoursePage
      loader: true,
      courseID: "",
      Courses: [],
      //Register User
      name: "",
      username: "",
      password: "",
      email: "",
      company: "WORK",
      usertype: "Agent",
      batch: "",
      firstCourseID: null,
    };
  }

  onEmailChange = (event) => {
    this.setState({ signInEmail: event.target.value });
  };

  onPasswordChange = (event) => {
    this.setState({ signInPassword: event.target.value });
  };

  isSignedIn = (status) => {
    // console.log(status, "status");
    this.setState({
      isSignedIn: status,
      blurChecker: status,
      visible: !status,
    });
  };

  onSubmitSignIn = () => {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });

    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/login",
      // "http://localhost:4000/lte/user/login",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: this.state.signInEmail,
          password: this.state.signInPassword,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response)
        if (response._id) {
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 6000);
          this.setState({
            visible: false,
            blurChecker: true,
            isSignedIn: true,
            user: response,
          });
          this.getCourses();
          // console.log(response);
        } else {
          this.setState({
            errors: response,
          });
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 0);
        }
        // console.log(this.state);
      });
  };

  componentDidMount() {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Enter key was pressed. Run your function.");
        this.onSubmitSignIn();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }

  getCourses = () => {
    this.setState({ loader: false });

    if (this.state.user._id) {
      this.setState({ loader: false });

      fetch(
        "https://work-web-server.herokuapp.com/lte/course/all"
        // "http://localhost:4000/lte/course/all"
      )
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            let orderedCourses = response.sort((a, b) =>
              a.order >= b.order ? 1 : -1
            );
            console.log(orderedCourses);
            this.setState({
              Courses: response,
              loader: false,
              firstCourseID: orderedCourses[0]._id,
            });
          } else {
            this.setState({ loader: false });
          }
        });

      // fetch(
      //   "https://sbhs-web-server.herokuapp.com/lte/course/all"
      //   // "http://localhost:4000/lte/course/all"
      // )
      //   .then((response) => response.json())
      //   .then((response) => {
      //     if (response) {
      //       this.setState({ Courses: response, loader: false });
      //     } else {
      //       this.setState({ loader: false });
      //     }
      //   });
    }
  };

  showChildrenDrawer = () => {
    this.setState({
      childrenDrawer: true,
      errors: {},
    });
  };

  onChildrenDrawerClose = () => {
    this.setState({
      childrenDrawer: false,
    });
  };

  onChangeRegister = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  registerNotification = () => {
    let placement = "bottomLeft";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 8,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>Congrats!</h3>
          <p>Your ID has been verified by WORK - HR.</p>
          <p>Kindly login LEARN TO EARN (LTE) and become a Champions at WORK</p>
          <h6>All The Best</h6>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  successAlert = (text) => {
    message.success(text);
  };

  onSubmitRegister = () => {
    message.loading({ content: "Registering User...", key });
    // console.log(this.state);
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/register",
      // "http://localhost:4000/lte/user/register",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: this.state.name,
          company: this.state.company,
          email: this.state.email,
          username: this.state.username,
          password: this.state.password,
          usertype: this.state.usertype,
          batch: this.state.batch,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("submit responce ", response);
        if (response && !response._id) {
          this.setState({
            errors: response,
          });
          setTimeout(() => {
            message.info({
              content: "Fill out Required Fields correctly",
              key,
              duration: 2,
            });
          }, 1000);
        } else if (response._id) {
          setTimeout(() => {
            message.success({
              content: "Registered Successfully!",
              key,
              duration: 2,
            });
          }, 1000);
          this.onChildrenDrawerClose();
          this.registerNotification();
        } else {
          setTimeout(() => {
            message.warning({
              content: "Registeration Failed!",
              key,
              duration: 2,
            });
          }, 1000);
        }
      });
  };

  onPageChange = (obj) => {
    this.setState({
      // page: obj.tab,
      courseID: obj.courseID,
    });
    console.log(obj.courseID);
  };

  render() {
    const { errors, isSignedIn } = this.state;
    // console.log(this.state.user);
    return (
      <Router history={hist}>
        <Particles className="particles" params={particlesOptions} />
        <Drawer
          width={500}
          closable={false}
          // onClose={this.onClose}
          style={{ backgroundColor: "#2c190698" }}
          visible={this.state.visible}
        >
          <Particles className="particles" params={particlesOptions} />
          <div className="notificationSignIn tc">
            <div className="signinLogo tc animate__animated animate__rotateIn">
              <img src={Logo} alt="Logo " width="100px" />
            </div>
            <br />
            <img src={UsersImage} alt="Locked" width="20px" />
            <input
              className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
              type="email"
              name="email-address"
              id="email-address"
              placeholder="Email"
              onChange={this.onEmailChange}
            />
            <Label className="red">{errors.email}</Label>
            <br />
            <img src={PwImage} alt="Locked" width="20px" />
            <input
              className="signinInput tc input-reset animate__animated animate__lightSpeedInRight"
              type="password"
              name="password"
              placeholder="Password"
              id="password"
              onChange={this.onPasswordChange}
            />
            <Label className="red">{errors.password}</Label>
            <br />
            <Button
              onClick={this.onSubmitSignIn}
              className="signinButtonLogin animate__animated animate__lightSpeedInLeft"
              loading={this.state.loadings[0]}
            >
              Sign in
            </Button>
            <br /> <br />
            <h6
              className="registerButtonLogin animate__animated animate__lightSpeedInRight white"
              // onClick={this.showDrawer}
            >
              Don't have an account?{" "}
            </h6>
            <h6
              onClick={this.showChildrenDrawer}
              className="grow white hover-orange"
              style={{ cursor: "pointer" }}
            >
              Sign Up
            </h6>
          </div>

          <Drawer
            title="Register Learn to Earn"
            width={500}
            closable={false}
            onClose={this.onChildrenDrawerClose}
            visible={this.state.childrenDrawer}
          >
            <div className="notificationSignIn tc">
              <br />
              <img src={UsersImage} alt="Locked" width="20px" />
              <input
                className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
                type="name"
                name="name"
                id="name"
                placeholder="Enter Full Name"
                onChange={this.onChangeRegister}
              />
              <Label className="red">{errors.name}</Label>
              <br />
              <img src={UsersImage} alt="Locked" width="20px" />
              <input
                className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
                type="email"
                name="email"
                id="email"
                placeholder="Enter Email"
                onChange={this.onChangeRegister}
              />
              <Label className="red">{errors.email}</Label>
              <br />
              <img src={UsersImage} alt="Locked" width="20px" />
              <input
                className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
                type="username"
                name="username"
                id="username"
                placeholder="Enter Username"
                onChange={this.onChangeRegister}
              />
              <Label className="red">{errors.username}</Label>
              <br />
              <img src={PwImage} alt="Locked" width="20px" />
              <input
                className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
                type="password"
                name="password"
                id="password"
                placeholder="Enter Password"
                onChange={this.onChangeRegister}
              />
              <Label className="red">{errors.password}</Label>
              <br />
              <img src={UsersImage} alt="Locked" width="20px" />
              <input
                className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
                type="number"
                name="batch"
                id="batch"
                placeholder="Enter Batch"
                onChange={this.onChangeRegister}
              />
              <Label className="red">{errors.batch}</Label>
              <br />
              <Button
                onClick={this.onSubmitRegister}
                className="signinButtonLogin animate__animated animate__lightSpeedInLeft"
              >
                Register
              </Button>
            </div>
          </Drawer>
        </Drawer>

        <div
          className={
            this.state.blurChecker === false && isSignedIn === false
              ? "blurContainer"
              : ""
          }
        >
          <NavBar
            className="homeHeder"
            user={this.state.user}
            isSignedIn={this.isSignedIn}
          />
          <Switch>
            <Route path={"/"} exact name={"Home"} component={Home} />
            <Route path={"/login"} exact name={"Login"} component={Login} />
            <Route
              path={"/trainer"}
              exact
              name={"Trainer"}
              component={Trainer}
            />
            <Route path={"/ceo"} exact name={"Mission"} component={Mission} />
            <Route
              path={"/courses"}
              name={"Courses"}
              exact
              component={() => (
                <Courses
                  user={this.state.user}
                  Courses={this.state.Courses}
                  firstCourseID={this.state.firstCourseID}
                  loader={this.state.loader}
                  isAuthed={true}
                  onPageChange={this.onPageChange}
                />
              )}
            />
            <Route path={"/admin"} exact name={"Admin"} component={Admin} />
            <Route
              path={"/itworld"}
              exact
              name={"Galleritworky"}
              component={Gallery}
            />
            <Route
              path={"/progress"}
              exact
              name={"MyLearning"}
              component={MyLearning}
            />
            <Route
              path={"/courses/:courseID"}
              exact
              name={"Course"}
              component={() => (
                <CoursesPage
                  courseID={this.state.courseID}
                  loader={this.state.loader}
                  courses={this.state.Courses}
                  firstCourseID={this.state.firstCourseID}
                  isAuthed={true}
                  user={this.state.user}
                />
              )}
            />
            <Route path={"/faqs"} exact name={"faqs"} component={Faqs} />
          </Switch>
          <Footer className="homeHeder" />
        </div>
      </Router>
    );
  }
}
